/* Scoped enhancements: Empire retains gallery, variants, search and cart ownership. */
(() => {
  function mount(root) {
    root.querySelectorAll('[data-kf-hero]').forEach(hero => {
      if (hero.dataset.kfReady) return;
      hero.dataset.kfReady = 'true';
      const track = hero.querySelector('[data-kf-track]');
      const slides = [...hero.querySelectorAll('[data-kf-slide]')];
      const dots = [...hero.querySelectorAll('[data-kf-dot]')];
      const controls = hero.querySelector('[data-kf-controls]');
      if (!track || !slides.length || !controls) return;
      controls.hidden = false;
      let active = 0;
      const go = index => {
        const next = (index + slides.length) % slides.length;
        track.scrollTo({left: slides[next].offsetLeft - slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      hero.querySelector('[data-kf-prev]').addEventListener('click', () => go(active - 1));
      hero.querySelector('[data-kf-next]').addEventListener('click', () => go(active + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => go(index)));
      let scheduled = false;
      track.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          active = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
          dots.forEach((dot, i) => i === active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
        });
      }, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        go(active + (event.key === 'ArrowRight' ? 1 : -1));
      });
      hero.addEventListener('shopify:block:select', event => {
        const index = slides.indexOf(event.target.closest('[data-kf-slide]'));
        if (index >= 0) go(index);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document));
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
